var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Block',{attrs:{"title":"采购申请执行情况"}},[_c('chart-pie',{staticClass:"chart",attrs:{"colors":['#3776ED', '#1ADBA5'],"types":['已采购', '未采购'],"dataList":_vm.dataList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }